import React from "react";
import { CLIENTS } from "../data/content";

/**
 * Full-bleed client logo grid: each square PNG fills its cell completely
 * (logo's baked-in dodgers background blends with the site section bg).
 * Inner scale crops out the PNG's internal padding so the glyph reads larger.
 * Hover: lime ring + slight scale, no color shift.
 */
const ClientLogoGrid = ({ total = 15 }) => {
  const fillers = Math.max(0, total - CLIENTS.length);
  return (
    <div
      className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5"
      data-testid="client-logo-grid"
    >
      {CLIENTS.map((c, i) => (
        <div
          key={c.name}
          className="aspect-square relative group overflow-hidden border-r border-b border-galactico/10 first:border-l [&:nth-child(5n+1)]:border-l"
          data-testid={`client-logo-${i}`}
        >
          <img
            src={c.logo}
            alt={c.name}
            decoding="async"
            className="absolute inset-0 w-full h-full object-cover scale-[1.06] transition-transform duration-500 group-hover:scale-[1.14]"
            draggable="false"
          />
          <span
            className="absolute inset-0 pointer-events-none border-[1.5px] border-lime opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            aria-hidden="true"
          />
          <span className="sr-only">{c.name}</span>
        </div>
      ))}
      {Array.from({ length: fillers }).map((_, i) => (
        <div
          key={`filler-${i}`}
          className="aspect-square border-r border-b border-galactico/10 [&:nth-child(5n+1)]:border-l flex items-center justify-center"
        >
          <span className="font-condensed uppercase tracking-[0.18em] text-galactico/35 text-xs md:text-sm">
            + Soon
          </span>
        </div>
      ))}
    </div>
  );
};

export default ClientLogoGrid;
